import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const ghg_assessment = apiUrl + "/ghg_assessment";
const routes = {
  label: "GHG Assessment",
  root: ghg_assessment,
  new: ghg_assessment + "/new",

  get_by_structure_id: ghg_assessment + "/get_by_structure_id",
  get_by_supply_chain_id: ghg_assessment + "/get_by_supply_chain_id",
  get_by_corporate_id: ghg_assessment + "/get_by_corporate_id",

  update_ghg_by_supply_chain: ghg_assessment + "/update_ghg_by_supply_chain",
  update_ghg_by_structure: ghg_assessment + "/update_ghg_by_structure",
  update_ghg_by_corporate: ghg_assessment + "/update_ghg_by_corporate",
};
export const GHG_Assessment = {
  label: "GHG Assessment",
  new: ({ supply_chain_id, structure_id, corporate_id }) =>
    postWithToken(routes.new, { supply_chain_id: supply_chain_id || null, structure_id: structure_id || null, corporate_id: corporate_id || null }),
  get_by_structure_id: (structure_id) => postWithToken(routes.get_by_structure_id, { structure_id }),
  get_by_supply_chain_id: (supply_chain_id) => postWithToken(routes.get_by_supply_chain_id, { supply_chain_id }),
  get_by_corporate_id: (corporate_id) => postWithToken(routes.get_by_corporate_id, { corporate_id }),
  update_ghg_by_supply_chain: (ghg) => postWithToken(routes.update_ghg_by_supply_chain, ghg),
  update_ghg_by_structure: (ghg) => postWithToken(routes.update_ghg_by_structure, ghg),
  update_ghg_by_corporate: (ghg) => postWithToken(routes.update_ghg_by_corporate, ghg),
};
